module.exports = __webpack_public_path__ + "img/icon-temperature.91048dba.svg";